import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import "./reports.css"
import { TfiEmail } from "react-icons/tfi";
import { HiOutlinePrinter } from "react-icons/hi2";
import { PiDownloadSimple } from "react-icons/pi";
import moment from 'moment';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import { BarLoader } from 'react-spinners';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { RiRefreshLine } from "react-icons/ri";
import Pagination from '../pagination/pagination';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { useCurrency } from '../../Layouts/currencyContext';

const PurchaseReturnReport = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [grnList, setGrnList] = useState();
    const [pageSize, setPageSize] = useState(20);
    const [Items, setItems] = useState([]);
    const [pagination, setPagination] = useState();
    const [SupplierList, setSuppliers] = useState();
    const gridRef = useRef();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const [currencyPrecision, setPrecision] = useState();
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        Status: [{ label: 'Filter By', value: '' }],
        email: "",
        PR: [{ label: 'Select PR', value: 'Select Category' }],
        PONo: [{ label: 'Select Purchase Order', value: 'Select Category' }],
        GrnNo: [{ label: 'Select GRN', value: 'Select Sub Category' }],
        StockType: [{ label: 'Select Stock Type', value: 'Select Sub Category' }],
        VendorName: [{ label: 'Select Supplier', value: 'Select Sub Category' }],
        VendorId: [{ label: 'Select Supplier Id', value: 'Select Sub Category' }],
    });
    const StatusFilter = [
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Aproved' },
        { value: '2', label: 'Hold' },
        { value: '3', label: 'Rejected' },
    ];
    useEffect(() => {
        fetchDropdownData();
        getItems()
    }, []);
    const fetchDropdownData = async () => {
        try {
            const apiService = new ApiService();
            let param = `?isActive=true`
            let Currencyres = await apiService.get('GET_CURRENCY_MASTER')
            const filteredDenominations = Currencyres?.data?.result?.find(currency => currency?.isDefault === true);
            setPrecision(filteredDenominations?.precision)
            const Items = await apiService.getApiParamater("GET_P_RETURN", param);
            setItems(Items?.data?.result);
            const suppliers = await apiService.get('GET_SUPPLIER');
            setSuppliers(suppliers?.data?.result);
            const grn = await apiService.get("GET_GRN");
            setGrnList(grn.data.result)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const dateFormatter = (params) => {
        const date = moment.utc(params.value).local();
        return date.format("DD-MMM-YYYY");
    };
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams({
                Status: formData.Status.value || "",
                VendorName: formData.VendorName?.label || "",
                PRNo: formData.PR?.value?.prNo || "",
                GRNNo: formData.GrnNo?.label || "",
            });
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);

            const res = await apiService.getApiParamater('GET_PURCHASE_RETURN', `?${params.toString()}`);
            setRowData(res?.data?.result?.reverse() || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const Comparison = [
        {
            headerName: 'PR NO', field: 'prNo', width: 120
        },
        {
            headerName: 'GRN No ', field: 'grnNo', width: 120
        },
        {
            headerName: 'Doc Date', field: 'delivery_Date', width: 120,
            valueFormatter: dateFormatter,
            comparator: dateComparator
        },
        { headerName: 'Ref No', field: 'invoiceRef', width: 120 },
        { headerName: 'Vendor Name', field: 'vendorName', width: 200 },
        {
            headerName: 'Status', field: 'status', suppressMovable: true, width: 150,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return (<div>Pending</div>);
                }
                else if (params.value === 1 || params.value === null) {
                    return (<div>Approved</div>);
                }
                else if (params.value === 5 || params.value === null) {
                    return (<div>Hold</div>);
                }
                else if (params.value === 3 || params.value === null) {
                    return (<div>Rejected</div>);
                } else {
                    return params.value;
                }
            }
        },
        { headerName: 'Item Code', field: 'itemCode', width: 110 },
        { headerName: 'Item Description', field: 'itemDescription', width: 300 },
        { headerName: 'UOM', field: 'uom', width: 110 },
        { headerName: 'QTY', field: 'qty', width: 110 },
        {
            headerName: 'Unit Price', field: 'unitPrice', width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 0)
        },
        { headerName: 'Vat Dec', field: 'vatDesc', width: 110 },
        { headerName: 'Vat %', field: 'vatPerc', width: 110 },
        {
            headerName: 'Vat Amount', field: 'vatAmount', width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 0)
        },
        {
            headerName: 'Amount', field: 'amount', width: 110,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision || 0)
        },
    ];
    const handleGrnChange = (selectedOption) => {
        setFormData({ ...formData, GrnNo: selectedOption });
    }
    const handlePRChange = (selectedOption) => {
        setFormData({ ...formData, PR: selectedOption });
    }
    const handleStatusFilter = (selectedOption) => {
        setFormData({ ...formData, Status: selectedOption });
    }
    const onBtnCSVExport = useCallback(() => {
        gridRef.current.api.exportDataAsCsv({
            fileName: 'itemsReport.csv'
        });
    }, []);
    const onBtPDFExport = useCallback(() => {
        const doc = new jsPDF();
        const rowData = [];
        const columnHeaders = [];
        const comparisonFields = ['prNo', 'grnNo', 'itemDescription', 'category', 'subCategory', 'stockType', 'unitMeasurement', 'warehouseLocation', 'purchasePrice'];

        Comparison.forEach(col => {
            columnHeaders.push(col.headerName);
        });

        gridRef.current.api.forEachNode((node) => {
            const row = [];
            comparisonFields.forEach(field => {
                row.push(node.data[field]);
            });
            rowData.push(row);
        });

        const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
        doc.addFileToVFS("Poppins-Regular.ttf", poppinsFont);
        doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
        doc.setFont("Poppins");
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text("Item Master Report", 75, 12);
        doc.text("__________________________", 60, 15);
        doc.setLineWidth(2);
        doc.autoTable({
            head: [columnHeaders],
            body: rowData,
            styles: {
                fontSize: 6,
            },
            headStyles: {
                fillColor: [209, 126, 6],
                textColor: [255, 255, 255],
                fontSize: 6,
            },
            columnStyles: {
                0: { cellWidth: 19 },
                1: { cellWidth: 19 },
                2: { cellWidth: 19 },
                3: { cellWidth: 19 },
                4: { cellWidth: 19 },
                5: { cellWidth: 19 },
                6: { cellWidth: 19 },
                7: { cellWidth: 19 },
                8: { cellWidth: 15 },
                9: { cellWidth: 15 },
                10: { cellWidth: 15 }
            },
            startY: 20,
            theme: 'striped'
        });
        doc.save('itemsReport.pdf');
    }, []);
    const handleClearFilters = () => {
        setFormData({
            Status: [{ label: 'Filter By', value: '' }],
            PR: [{ label: 'Select PR', value: 'Select Category' }],
            PONo: [{ label: 'Select Purchase Order', value: 'Select Category' }],
            GrnNo: [{ label: 'Select GRN', value: 'Select Sub Category' }],
            VendorId: [{ label: 'Select Supplier Id', value: 'Select Sub Category' }],
            StockType: [{ label: 'Select Stock Type', value: 'Select Sub Category' }],
            VendorName: [{ label: 'Select Supplier', value: 'Select Sub Category' }],
        });
        getItems()
    };
    const handleSupplierChange = (selectedOption) => {
        setFormData({
            ...formData,
            VendorId: { value: selectedOption.value, label: selectedOption.value.record_Id },
            VendorName: { value: selectedOption.value, label: selectedOption.value?.supplierName }
        });
    }
    const handleSupplierIdChange = (selectedOption) => {
        setFormData({
            ...formData,
            VendorId: { value: selectedOption.value, label: selectedOption.label },
            VendorName: { value: selectedOption.value, label: selectedOption.value?.supplierName }
        });
    }
    const SendEmail = async () => {
        try {
            if (!formData.email) {
                toast.warning("Enter User Email to send Report")
                return;
            }
            const requestBody = {
                // toEmail: "shahzaibawan864@gmail.com",
                toEmail: formData.email,
                subject: "Purchase Return Report",
                body: `
                <div className='printhead2 mb-5 px-4'>
                    <table>
                        <thead className='dynoTable' style='background-color: #5B93FF; color: #fff;'>
                            <tr>
                                <th>PO No</th>
                                <th>Requisition NO </th>
                                <th>PO Date</th>
                                <th>Vendor</th>
                                <th>Payment Term</th>
                                <th>Supplier Contact</th>
                                <th>Department</th>
                                <th>Curr Code</th>
                                <th>status</th>
                                <th>Cost center 1</th>
                                <th>Cost center 2</th>
                                <th>Cost center 3</th>
                                <th>Cost center 4</th>
                                <th>Delivery Status</th>
                                <th>Item Code</th>
                                <th>Item Description</th>
                                <th>UOM</th>
                                <th>QTY</th>
                                <th>Unit Price</th>
                                <th>Vat %</th>
                                <th>Vat Amount</th>
                                <th>Amount</th>
                                <th>Net Amount</th>
                                <th>GRN Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowData?.map((row, index) => `
                                <tr key=${index}>
                                    <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.pOrderNo}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.requisitionNo}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.docDate}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.vendorName}' /></td>
                                    <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.terms}' /></td>
                                    <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.attention}' /></td>
                                    <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.department}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.currencyCode}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.status}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter1}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter2}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter3}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter4}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.deliveryStatus}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemCode}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemDescription}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.uom}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.qty}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.unitPrice}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatPerc}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(currencyPrecision || 0) || 0}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.netAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.grnQty}' disabled /></td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>`
            }
            const apiService = new ApiService();
            const response = await apiService.post("SEND_EMAIL", requestBody);
            if (response.status === 200) {
                onCloseModal()
                toast.success("Email send successfully")
                handleClearFilters()
            }

        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-9'>
                    <div className='row pb-2' >
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.VendorId}
                                onChange={(selectedOption) => handleSupplierIdChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.record_Id }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.VendorName}
                                onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.GrnNo}
                                onChange={(selectedOption) => handleGrnChange(selectedOption)}
                                options={grnList?.map((rec) => ({ value: rec, label: `${rec?.grnNo}` }))}
                            />
                        </div>
                    </div>
                    <div className='row' >
                        <div className='col-4'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Status}
                                options={StatusFilter}
                                onChange={handleStatusFilter}
                            />
                        </div>
                        <div className='col-4'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.PR}
                                onChange={(selectedOption) => handlePRChange(selectedOption)}
                                options={Items?.map((rec) => ({ value: rec, label: `${rec?.prNo}` }))}
                            />
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    <div onClick={() => getItems()} className='mainbtnGry flex-end gap-2'>
                        <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Search</div>
                    </div>
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Purchase Return Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={onBtnCSVExport} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                {/* <DropdownItem onClick={onBtExcelExport} className='gap-3 d-flex center'><LiaFileExcel/><div>Export Excel</div></DropdownItem> */}
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className='mainbtnRed flex-end '><HiOutlinePrinter size={25} /></div>
                    <div className='mainbtn flex-end gap-1' onClick={onOpenModal}>
                        <div className='center'><TfiEmail size={25} /></div>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            rowSelection={'single'}
                            columnDefs={Comparison}
                            ref={gridRef}
                            suppressExcelExport={true}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
            <Modal size="md"
                show={emailModal} onHide={() => onCloseModal()}
                onRequestClose={() => onCloseModal()}
                contentLabel='Email Modal'
                style={customStyles} closeButton
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            type='email'
                            className="form-Input w-100"
                            id="validationCustom02"
                            value={formData.email}
                            name="email"
                            onChange={handleInputChange}
                            placeholder='Enter Email'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={SendEmail} >Save</button>
                </Modal.Footer>
            </Modal >
        </div>
    );
};
export default PurchaseReturnReport;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};